
import React, { useEffect, useState } from 'react';
import client from '../contenful/client';
import Nav from '../components/Nav';
import topimg from '../images/top.png';
import aboutlogo from '../images/aboutLogo.png';
import '../components/Hero.css';
import AboutCard from '../components/AboutCard';
import AboutCard2 from '../components/AboutCard2';
import Footer from '../components/Footer';
import FounderCard from '../components/FounderCard';
import TeamCard from '../components/TeamCard';
import './About.css';
const About = () => {
  const [about, setAbout] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0); // Initially, first card is open

  const handleCardClick = (index) => {
    setActiveIndex(index);
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const entries = await client.getEntries({ content_type: "aboutUs" });
        console.log("Fetched Contentful Entries:", entries);
        setAbout(entries.items);
      } catch (err) {
        console.error("Error fetching Contentful data:", err);
      }
    };
    fetchData();
  }, []);


  return (
    <>
    {about.map((item, index) => {
      console.log("Current Entry Fields:", item.fields);
      //data fetching
     const WhoWeheadline = item.fields.whoWeAreTitle;
     const WhoWedesc = item.fields.whoWeAreDesc;

     const sec2tittle1 = item.fields.sec2Tittle;
     const sec2desc = item.fields.sec2Desc; 
     const sec2desc1 = item.fields.sec2Desc1;     
     const sec2tittle2 = item.fields.sec2Tittle2;
     const sec2desc2 = item.fields.sec2Desc2;   
     const sec2tittle3 = item.fields.sec2Tittle3;
     const sec2desc3 = item.fields.sec2Desc3; 
     
     const rows = [
      item.fields.rowTitle1,
      item.fields.rowTitle2,
      item.fields.rowTitle3
    ].filter(Boolean); // filters out undefined/null
    
     const sec3 = item.fields.sec3Cards?.map((card2, card2Index) => ({
      image: `https:${card2.fields.file.url}`,
      title: card2.fields.title,
      desc: card2.fields.description,
      
     })) || [];


     const img1 = `https:${item.fields.sec4Img1.fields.file.url}`;
     const img2 = `https:${item.fields.sec4Img2.fields.file.url}`;

     const foundersec = item.fields.founderImg?.map((founder) => {   
      return {
        image: `https:${founder.fields.file.url}`,
        founderhovertitle: founder.fields.title || "No Title",
        founderhoverdesc: founder.fields.description || "No Description",
      };
    }).filter(Boolean); 


    const teamsec = item.fields.teamCard?.map((team) => {   
      return {
        image: `https:${team.fields.file.url}`,
        teamhovertitle: team.fields.title || "No Title",
        teamhoverdesc: team.fields.description || "No Description",
      };
    }).filter(Boolean); 

      return(
        <div key={index} className='top-sec'>
           {/* top section */}
           <Nav logo={aboutlogo} hamburgerColor='black' plusColor='white' logoSize = '300px' />
           <img className='top-img' src={topimg} />


            {/* who we are section */}
           <div className='ab-sec2'>
              <div className='ab-sec2-left'>
                <h3>WHO ARE WE</h3>
                <svg width="80%" height="3" margin = "0">
                  <line x1="0" y1="0" x2="100%" y2="0" stroke="white" stroke-width="3"/>
                </svg>
              </div>
             <div className='ab-sec2-right'>
                <h2>{WhoWeheadline}</h2>
                <p>{WhoWedesc}</p>
             </div>
           </div>


            {/* numbers section */}
            <div className='ab-Num'>
              {rows.map((row, i) => (
                <div className={`ab-col${i + 1}`} key={i}>
                  <h2>
                    <span className="big-text">{row?.[0] || ''}</span><br />
                    <span className="small-text">{row?.[1] || ''}</span>
                  </h2>
                </div>
              ))}
            </div>





            {/* cards section */}
            
            <div className="ab-sec3">
              {[sec2tittle1, sec2tittle2, sec2tittle3].map((title, index) => {
                let cardClass = "card-wrapper";
                
                if (activeIndex === index) {
                  cardClass += " active";
                } else if (activeIndex === 0 && index === 1) {
                  cardClass += " inactive-7F"; // When 1st is active, 2nd gets #7F7F7F
                } else if (activeIndex === 0 && index === 2) {
                  cardClass += " inactive-CC"; // When 1st is active, 3rd gets #CCCCCC
                } else if (activeIndex === 1 && index === 0) {
                  cardClass += " inactive-7F"; // When 2nd is active, 1st gets #7F7F7F
                } else if (activeIndex === 1 && index === 2) {
                  cardClass += " inactive-CC"; // When 2nd is active, 3rd gets #CCCCCC
                } else if (activeIndex === 2 && index === 0) {
                  cardClass += " inactive-CC"; // When 3rd is active, 1st gets #CCCCCC
                } else if (activeIndex === 2 && index === 1) {
                  cardClass += " inactive-7F"; // When 3rd is active, 2nd gets #7F7F7F
                }

                return (
                  <div
                    key={index}
                    className={cardClass}
                    onMouseEnter={() => handleCardClick(index)}
                  >
                    <AboutCard
                      tittle={title}
                      desc={
                        activeIndex === index
                          ? index === 0 
                            ? [sec2desc, sec2desc1] // Pass as an array for first card
                            : [sec2desc2, sec2desc3][index - 1] // Ensure string for other cards
                          : ""
                      }
                      
                    />
                  </div>
                );
              })}
            </div>
            


            {/* what do we do  section */}
            <div className='ab-sec4'>
                <h2>WHAT DO WE DO</h2>
                <svg width="37%" height="3">
                  <line x1="0" y1="0" x2="100%" y2="0" stroke="white" strokeWidth="3" />
                </svg>
                <div className='ab-sec4-card2'>
                  {sec3?.map((card2, index) => (
                    <AboutCard2 
                      key={index} 
                      image={card2.image} 
                      title={card2.title} 
                      desc={card2.desc} 
                      index={index}
                    />
                  ))}
                </div>
              </div>


            {/* image */}
            <div className='ab-sec5'>
              <img src={img1} alt="Left Image" className="sec5-left-img" />
              <img src={img2} alt="Right Image" className="sec5-right-img" />
            </div>



            {/* founder section */}
      {/* Founder Section */}
            <div className='founder'>
              <h2>BEHIND THE SCREEN</h2>
                <svg width="37%" height="3">
                  <line x1="0" y1="0" x2="100%" y2="0" stroke="white" strokeWidth="3" />
                </svg>
              <div className='founder-cards'>
                {foundersec.map((founder, founderIndex) => (
                  <FounderCard
                    key={founderIndex}
                    image={founder.image}
                    title={founder.founderhovertitle}
                    desc={founder.founderhoverdesc}
                  />
                ))}
              </div>
            </div>


            {/* team section */}
            <div className='team'>
              {teamsec.map((team,teamIndex) => (

               <TeamCard
                key = {teamIndex}
                image  = {team.image}
                title= {team.teamhovertitle}
                
               />
              ))}
            </div>

            <Footer  />
            







            


          

          
        </div>
      )

      
    })}
    </>
  )
}

export default About